import module from "shared-assets/lib/sdk/featureSetAreas";

/**
 * @ngdoc service
 * @name kareo.featureSetAreas:featureSetAreas
 * @description
 * Use `featureSetAreas` to fetch status of featureSetAreas keys in chrome header
 */

/**
 * @ngdoc
 * @name #load
 * @methodOf kareo.featureSetAreas:featureSetAreas
 * @description
 * Does the http call to fetch the features. If the call is already made, it returns earlier fetched values.
 * <br>
 * Example usage :
 * ```js
 * featureSetAreas.load().then(function(features){
 *  var status = features['feature-set.area.my-settings-marketing'];
 * });
 * ```
 * @returns {object} <br><br>
 * ```js
 *  {
 *    'feature-set.areas.my-settings-marketing' : {
 *      show: true,
 *      enabled: false
 *    }
 *  }
 * ```
 */

angular.module('kareo.featureSetAreas', []).factory('featureSetAreas', [
    '$q',
    $q => {
        return {
            load: () => $q.when(module.load()),
        };
    },
]);